import React, { useState, useEffect } from "react";
import { Card, Avatar, Typography } from "antd";
import { AlertCircle } from "lucide-react";
import { get_api_function } from '@/utils/api';
import { useNavigate } from "react-router";
import { defaultColors } from '@/themes/antd-theme';

const { Paragraph } = Typography;

// ==============================|| ALERT NOTIFICATION PAGE ||============================== //

const AlertNotificationPage = () => {
  const [notifications_data, set_notifications_data] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    get_api_function("/get_operation_alert", (res) => {
      set_notifications_data(res?.data?.data || []);
    });
  }, []);

  return (
    <div className="p-3">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {notifications_data?.map((item, index) => (
          <Card key={index} className="hover:shadow-md transition-shadow">
            <div className="flex gap-3">
              <Avatar
                size={36}
                style={{
                  color: defaultColors.warning,
                  backgroundColor: defaultColors.palette.amber[50],
                }}
              >
                {item.operation_name
                  .split(" ")
                  ?.slice(0, 2)
                  .map((word) => word[0])
                  .join("")
                  .toUpperCase()}
              </Avatar>
              <div className="flex-1">
                <Paragraph
                  ellipsis={{
                    rows: 2,
                    expandable: true,
                    symbol: "more",
                  }}
                  className="text-sm font-medium mb-2"
                >
                  {item?.msg}
                </Paragraph>

                <div className="flex flex-col gap-1 text-xs">
                  <div className="grid grid-cols-2 gap-1">
                    <span className="text-gray-600 dark:text-gray-400">Batch:</span>
                    <span className="text-gray-900 dark:text-gray-100 truncate">
                      {item?.batch_number}
                    </span>

                    <span className="text-gray-600 dark:text-gray-400">Operation:</span>
                    <span className="text-gray-900 dark:text-gray-100 truncate">
                      {item?.operation_name}
                    </span>

                    <span className="text-gray-600 dark:text-gray-400">Duration:</span>
                    <span className="text-gray-900 dark:text-gray-100">
                      {item?.duration}
                    </span>

                    <span className="text-gray-600 dark:text-gray-400">Running Time:</span>
                    <span className="text-gray-900 dark:text-gray-100">
                      {item?.running_time}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AlertNotificationPage;
